import { Box, Grid, IconButton, Button, Typography } from '@mui/material'
import React from 'react'
import { IconBase } from 'react-icons'
import AdbIcon from '@mui/icons-material/Adb';
import data from '../Comp/Data';
import Icons from '../Comp/Icons';
import { RevealWrapper } from 'next-reveal'
// import {RevealList} from  'next-reveal'

const Sets = () => {
    return (
        <div>
            <Box className='container'>
                <RevealWrapper origin='left' delay={200} duration={1000} distance='500px' reset={true} viewOffset={{ top: 25, right: 0, bottom: 10, left: 5 }}>

                    <Typography variant='h4' className='mt-3' sx={{ color: "#31F711" }}>
                        {"Languages and Tools"}
                    </Typography>
                </RevealWrapper>
                <Box>
                    <Grid container>
                        {/* <RevealList interval={60} delay={500}  className='flex flex-wrap items-center justify-center'> */}
                        {data.map((x, i) => {
                            return (
                                <Grid className='p-2 mt-2 overflow-hidden' item md={6} sm={12} xs={12}>
                                    {/* <RevealWrapper  origin='right' delay={200} duration={2000} distance={{md:"50px",sm:"20px",xs:"80px"}} reset={true} > */}
                                    <RevealWrapper origin='right' delay={200} duration={2000} distance={"500px"} reset={true} >
                                        <Box sx={{ fontFamily: "initial" }} className='border d-flex justify-content-between rounded-4 '>
                                            <Typography variant='h5' className='mt-1 ps-2' sx={{ fontFamily: "initial" }}>{x.title}</Typography>
                                            <Icons icon={x.icon} alts={"no ava"} />
                                        </Box>
                                    </RevealWrapper>
                                </Grid>
                            )
                        })}
                        {/* </RevealList> */}

                    </Grid>
                </Box>

            </Box>
        </div>
    )
}

export default Sets
